export const microservicesSchema = {
    type: 'object',
    properties: {
        profiles: {
            type: 'object',
            properties: {
                port: { type: 'string' },
                host: { type: 'string' },
            },
        },
        organisations: {
            type: 'object',
            properties: {
                port: { type: 'string' },
                host: { type: 'string' },
            },
        },
        news: {
            type: 'object',
            properties: {
                port: { type: 'string' },
                host: { type: 'string' },
            },
        },
        notifications: {
            type: 'object',
            properties: {
                port: { type: 'string' },
                host: { type: 'string' },
            },
        },
        cards: {
            type: 'object',
            properties: {
                port: { type: 'string' },
                host: { type: 'string' },
            },
        },
        requests: {
            type: 'object',
            properties: {
                port: { type: 'string' },
                host: { type: 'string' },
            },
        },
        notices: {
            type: 'object',
            properties: {
                port: { type: 'string' },
                host: { type: 'string' },
            },
        },
        merchant: {
            type: 'object',
            properties: {
                port: { type: 'string' },
                host: { type: 'string' },
            },
        },
        address: {
            type: 'object',
            properties: {
                port: { type: 'string' },
                host: { type: 'string' },
            },
        },
        payments: {
            type: 'object',
            properties: {
                port: { type: 'string' },
                host: { type: 'string' },
            },
        },
        ecolocal: {
            type: 'object',
            properties: {
                port: { type: 'string' },
                host: { type: 'string' },
            },
        },
    },
};
